import React from "react";
// React Table
import { Table } from "react-bootstrap";
// Styled Components
import styled from "styled-components";

const CustomTd = styled.td`
  background-color: #eeeeee;
`;

const VistaParticipacion = ({ datosParticipacion }) => {
  return (
    <Table bordered responsive>
      <tbody>
        <tr>
          <CustomTd className={"w-50"}>
            <span>Descripción</span>
          </CustomTd>
          <td>{datosParticipacion?.description || <small>No especificado</small>}</td>
        </tr>
        {/* <tr>
          <CustomTd>
            <span>Participación Con</span>
          </CustomTd>
          <td>{datosParticipacion?.type || <small>No especificado</small>}</td>
        </tr> */}
      </tbody>
    </Table>
  );
};

export default VistaParticipacion;
